import { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import './SettingsModal.css';

const DeleteGroupModal = ({ handleClose, show, rowData, onDelete }) => {
    const [group, setGroup] = useState([]);

    useEffect(() => {
        let array = rowData.map((item) => ({
            groupID: item,
            deletedBy: localStorage.getItem('badgeID'),
        }));
        setGroup(array);
    }, [rowData]);

    const deleteFile = () => {
        onDelete({
            group,
        });
    };

    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header>
                <Modal.Title
                    className='delete-modal-title'
                    style={{ color: '#c02d2e', marginBottom: '0px' }}
                >
                    Delete Group
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>Are you sure you wish to delete this group?</Modal.Body>
            <Modal.Footer>
                <Button variant='danger' onClick={deleteFile}>
                    Delete Group
                </Button>
                <Button variant='outline-secondary' onClick={handleClose}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default DeleteGroupModal;
